import React from 'react';
import * as styles from './UpgradeBadge.module.scss';
import Badge from '../components/Badge';
import boltIcon from '../icons/non-prefilled/16x16/bolt.svg';

interface UpgradeBadgeProps {
  onClick?: () => void;
}

const UpgradeBadge = ({ onClick }: UpgradeBadgeProps) => (
  <Badge
    onClick={onClick}
    icon={<Badge.Icon className={styles.boltIcon}>{boltIcon}</Badge.Icon>}
  >
    UPGRADE
  </Badge>
);

export default UpgradeBadge;
